import { RG_TYPE as o } from "@project-rouge/rg-core";
import { SvgWindow as t } from "./index9.js";
import { jsx as r } from "react/jsx-runtime";
var l = /* @__PURE__ */ ((e) => (e.floorPlan = "floorPlan", e.floorPlanBW = "floorPlanBW", e))(l || {});
const a = {
  floorPlanBW: {
    [o.Core]: {
      showImage: {
        fill: "white",
        stroke: "black",
        strokeWidth: 0.03
      }
    },
    [o.Corridor]: {
      showImage: {
        fill: "white",
        stroke: "black",
        strokeWidth: 0.03
      }
    },
    [o.Floor]: {
      showImage: {
        fill: "white",
        stroke: "black",
        strokeWidth: 0.03
      }
    },
    [o.Wall]: {
      showImage: {
        fill: "white",
        stroke: "black",
        strokeWidth: 0.03
      }
    },
    [o.Opening]: {
      showImage: {
        fill: "white",
        stroke: "white",
        strokeWidth: 0.03
      }
    },
    [o.Window]: {
      showImage: {
        fill: "white",
        stroke: "black",
        strokeWidth: 0.01
      },
      showCustom: (e) => /* @__PURE__ */ r(t, {
        ...e
      })
    },
    [o.Door]: {
      showImage: {
        fill: "white",
        stroke: "black",
        strokeWidth: 0.01
      }
    },
    [o.Column]: {
      showImage: {
        fill: "blue",
        stroke: "black",
        strokeWidth: 0.01
      }
    },
    [o.Room]: {
      showText: !0
    }
  },
  floorPlan: {
    [o.Core]: {
      showImage: {
        fill: "#DADADA",
        stroke: "#DADADA",
        strokeWidth: 1e-3
      }
    },
    [o.Corridor]: {
      showImage: {
        fill: "#DADADA",
        stroke: "#DADADA",
        strokeWidth: 1e-3
      }
    },
    [o.Entrance]: {
      showImage: {
        fill: "#DADADA",
        stroke: "#DADADA",
        strokeWidth: 1e-3
      }
    },
    [o.TechnicalSpace]: {
      showImage: {
        fill: "white",
        stroke: "#DADADA",
        strokeWidth: 1e-3
      }
    },
    [o.Module]: {
      showImage: {
        stroke: "#858585",
        strokeWidth: 1e-3
      }
    },
    [o.Floor]: {
      showImage: {
        fill: "white",
        fillOpacity: 1e-3,
        stroke: "#858585",
        strokeWidth: 0.01
      }
    },
    [o.Wall]: {
      showImage: {
        fill: "#5F5F5F",
        stroke: "#5F5F5F",
        strokeWidth: 0.01
      }
    },
    [o.Facade]: {
      showImage: {
        fill: "#5F5F5F",
        stroke: "#5F5F5F",
        strokeWidth: 0.01
      }
    },
    [o.Opening]: {
      showImage: {
        customFill: (e) => e.parent.parent.color
      }
    },
    [o.Window]: {
      showImage: {
        fill: "white",
        stroke: "#95969a",
        strokeWidth: 0.01
      },
      showCustom: (e) => /* @__PURE__ */ r(t, {
        ...e
      })
    },
    [o.Door]: {
      showImage: {
        fill: "white",
        stroke: "#858585",
        strokeWidth: 0.01
      }
    }
  }
};
export {
  a as SvgStylePresets,
  l as SvgStylePresetsEnum
};
//# sourceMappingURL=index8.js.map
